import React, { useEffect, useState } from 'react';
import { apiConstants, getGeneric } from '../../common/constants';
import { convertToCSV, downloadCSV, formatDate, parseDateAndTime } from '../../helpers/UtilityHelper';
import ProzoDataGrid from '../../common/ProzoDataGrid';
import { Button, Card, CardContent, CardHeader, Chip, Grid, Typography } from '@mui/material';
import Loader from '../../common/Loader';
import { MerchantFilterCached } from '../../common/ProshipFormComponents';
import { FormProvider, RHFDateRangePickerField } from '../../common/hook-form';
import { LoadingButton } from '@mui/lab';
import { useForm } from 'react-hook-form';
import { Download } from '@mui/icons-material';

const headers = [
    { label: "Transaction ID", key: "transactionId" },
    { label: "Credit Amount", key: "credit" },
    { label: 'Debit Amount', key: 'debit' },
    { label: 'Source', key: 'transactionSource' },
    { label: 'Status', key: 'transactionStatus' },
    { label: 'Trans. Time', key: 'date' }
];

const OtherTransaction = () => {
    const [walletHistory, setWalletHistory] = useState([]);
    const [page, setPage] = useState(0);
    const [sizePerPage, setSizePerPage] = useState(40);
    const [rowCountState, setRowCountState] = useState(0);
    const [loading, setLoading] = useState(false);
    const [merchant, setMerchant] = useState();
    const [fromDate, setFromDate] = useState();
    const [toDate, setToDate] = useState();
    const [btnLoading, setBtnLoading] = useState(false)


    const columns = [

        {
            field: "transactionAmount",
            headerAlign: "center",
            hideSortIcons: true,
            flex: 1,
            headerName: "Transaction Amount",
            renderCell: (params) => {
                const { row } = params;
                const transactionAmount = row.credit && row.credit > 0 ? row.credit : row.debit;
                return 'Rs.' + transactionAmount;
            },
        },
        {
            field: "date",
            headerAlign: "center",
            hideSortIcons: true,
            headerName: "Date",
            flex: 1,
            renderCell: (params) => {
                const { row } = params;
                return parseDateAndTime(row.date);
            },
        },
        {
            field: "transactionType",
            headerAlign: "center",
            hideSortIcons: true,
            flex: 1,
            headerName: "Transaction Type",
            renderCell: (params) => {
                const { row } = params;
                const transactionType = row.credit && row.credit > 0 ? 'Credit' : 'Debit';
                const color = row.credit && row.credit > 0 ? "success" : "error";
                return (
                    <>
                        <Grid container rowSpacing={2}>
                            <Grid item xs={12}>
                                <Chip size="small" color={color} label={transactionType} />
                            </Grid>
                        </Grid>
                    </>
                );
            },
        },
        {
            field: "transactionStatus",
            headerAlign: "center",
            hideSortIcons: true,
            flex: 1,
            headerName: 'Transaction Status',
        },
        {
            field: "transactionSource",
            headerAlign: "center",
            hideSortIcons: true,
            flex: 1,
            headerName: 'Transaction Source',
        },
        {
            field: "transactionId",
            headerAlign: "center",
            hideSortIcons: true,
            flex: 1,
            headerName: 'Transaction Id',
        },


    ]


    const loadOtherTransaction = () => {
        if (merchant && fromDate && toDate) {
            setLoading(true);
            getGeneric(
                `${apiConstants.OTHER_TRANSACTION}?from_date=${formatDate(fromDate, "yyyy-MM-dd")}&to_date=${formatDate(toDate, "yyyy-MM-dd")}&merchantId=${merchant}&limit=100`
            ).then(response => {
                setLoading(false);
                setWalletHistory(response.data);
                setRowCountState(response.data.length);
            })
                .catch(err => {
                    console.error(err)
                    setLoading(false);
                });
        }
    }

    useEffect(() => {
        loadOtherTransaction();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [merchant, fromDate, toDate]);


    const methods = useForm({
        defaultValues: {
            merchant: "",
            fromDate: '',
            toDate: '',
        },
    });
    const { handleSubmit, reset } = methods;

    const onSubmit = async (data) => {
        if (data.merchant) {
            setMerchant(data.merchant)
        }
        if (data.fromDate) {
            setFromDate(data.fromDate)
        }
        if (data.toDate) {
            setToDate(data.toDate)
        }
    };

    const downloadTransactionFile = () => {
        if (merchant && fromDate && toDate) {
            setBtnLoading(true)
            getGeneric(
                `${apiConstants.OTHER_TRANSACTION}?from_date=${formatDate(fromDate, "yyyy-MM-dd")}&to_date=${formatDate(toDate, "yyyy-MM-dd")}&merchantId=${merchant}&limit=100000`
            ).then(response => {
                setBtnLoading(false);
                const csvData = convertToCSV((response.data && response.data.length > 0) ? response.data : [], headers);
                const filename = 'other-transaction.csv';
                downloadCSV(csvData, filename);
            }).catch(err => {
                console.error(err);
                setBtnLoading(false);
            });
        }
    }


    return (
        <>
            <Card>
                <CardHeader
                    subheader={
                        <Grid item xs={12}>
                            <Typography variant='caption' color={'error'} sx={{ fontWeight: 'bold' }}>Please select merchant and date range to view transactions.</Typography>
                        </Grid>
                    }
                    action={
                        <LoadingButton loading={btnLoading} onClick={() => { downloadTransactionFile() }} variant="contained" color="warning"
                            disabled={!walletHistory?.length > 0}
                            size='small'
                            startIcon={<Download />}
                        >Download</LoadingButton>
                    }
                />
                <CardContent>
                    <FormProvider
                        methods={methods} onSubmit={handleSubmit(onSubmit)}>
                        <Grid container spacing={2} sx={{ mb: 2 }}>
                            <Grid item xs={12}>
                                <Grid container spacing={2} alignItems="center">
                                    <Grid item xs={3} style={{ overflow: 'hidden' }}>
                                        <MerchantFilterCached />
                                    </Grid>
                                    <Grid item xs={3}>
                                        <RHFDateRangePickerField name="date_range" label="Date Range" maxDate={new Date()} />
                                    </Grid>
                                    <Grid item xs={3} display='flex'>
                                        <Button type="submit" variant="contained" size='small' color="primary">Search</Button>
                                        <Button sx={{ ml: 1 }} type="button" variant="contained" size='small' color="error" onClick={() => {
                                            reset({
                                                merchant: '',
                                                fromDate: '',
                                                toDate: ''
                                            })
                                            setMerchant()
                                            setFromDate()
                                            setToDate()
                                            setWalletHistory([])
                                        }}>Reset</Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </FormProvider>
                </CardContent>
            </Card>
            <Grid item container spacing={2} sx={{ mt: 2 }}>
                {(loading) && <Loader />}
                <Grid item xs={12}>
                    <ProzoDataGrid columns={columns}
                        autoHeight={true}
                        rows={walletHistory.map((row, index) => ({ ...row, id: index }))}
                        sizePerPage={sizePerPage}
                        setSizePerPage={setSizePerPage}
                        setPage={setPage}
                        page={page}
                        pagination={true}
                        hideFooterPagination={false}
                        // filterMode={"server"}
                        paginationMode={'client'}
                        rowHeight={180}
                        rowCount={rowCountState || 0}
                        getRowId={(row) => row.id}
                    />
                    {/* )} */}
                </Grid>
            </Grid>
        </>

    );
}

export default OtherTransaction;